import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IComplaint } from 'app/models/compliance/complaint';
import { Observable } from 'rxjs';
import { IIHCAgency } from '../../models/compliance/ihc-agency';

@Injectable({providedIn: 'root'})
export class ComplaintService {

  public api: string = environment.publicApi + 'Complaint/'
  private http = inject(HttpClient);

  createComplaint(): Observable<IComplaint>{
    return this.http.post<IComplaint>(this.api + 'CreateComplaint', null);
  }

  submitComplaint(complaint: IComplaint): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'SubmitComplaint', complaint);
  }

  deleteComplaint(complaintId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteComplaint/' + complaintId);
  }

  getIhcAgencies(): Observable<IIHCAgency[]>{
    return this.http.get<IIHCAgency[]>(this.api + 'GetIHCAgencies');
  }

  getComplaintByClient(complaintId: number, clientId: string): Observable<IComplaint>{
    return this.http.get<IComplaint>(this.api + 'GetComplaintByClient/' + complaintId + '/' + clientId);
  }

  updateClientNarrative(complaintId: number, clientId: string, clientNarrative: string): Observable<boolean>{
    const narrative = { narrative: clientNarrative };
    return this.http.post<boolean>(this.api + 'UpdateClientNarrative/' + complaintId + '/' + clientId, narrative);
  }

}
